import { useFormContext } from "react-hook-form";
import Card from "../../../components/card/card";
import { useContext, useState } from "react";
import PhoneNumberFormField from "../../../../../components/form-fields/phone-number-field/phone-number-form-field";
import { USER_APPOINTMENT_ACTIONS, UserAppointmentContext } from "../../../context/user-appointment-context";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { useAppDispatch } from "../../../../../store/hooks";
import { v4 as uuid } from "uuid";
import { sendOtpForNumber } from "../../../../../actions";

const PhoneForm = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { control, watch } = useFormContext();
  const number = watch("mobile");
  const isNumber = !number;
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const onHandleConfirmBtn = async () => {
    setLoading(true);
    try {
      await sendOtpForNumber({ phone: number });
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
        payload: activeStep + 1,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title={"Pair your phone number"}
      btnTitle={"Continue"}
      onHandleClick={onHandleConfirmBtn}
      progress={activeStep * 5}
      disabledConfirmBtn={isNumber}
      isLoadingConfirmBtn={loading}
    >
      <PhoneNumberFormField
        name="mobile"
        label={"Your phone number"}
        control={control}
      />
    </Card>
  );
};

export default PhoneForm;
